import { createContext } from 'react'

import { freeze } from 'utils/dom'

export const R_INPUT = {
  DID_SAVE: Symbol('DID_SAVE'),
  DID_CHANGE: Symbol('DID_CHANGE'),
  DID_FOCUS: Symbol('DID_FOCUS'),
  DID_CANCEL: Symbol('DID_CANCEL'),
  CHANGE_OK: Symbol('CHANGE_OK'),
  INIT: Symbol('INIT'),
  REFRESH: Symbol('REFRESH')
}

export const CHG = {
  OK: Symbol('OK'),
  DIRTY: Symbol('DIRTY'),
  FAILED: Symbol('FAILED'),
  SAVED: Symbol('SAVED'),
  SAVING: Symbol('SAVING')
}

////////////////////////////////////////////////////////////////////////////////
export function reducer(state, { type, ...args }) {
  switch (type) {
    case R_INPUT.DID_CHANGE:
      return didChange(state, args)
    case R_INPUT.DID_FOCUS:
      return didFocus(state, args)
    case R_INPUT.DID_CANCEL:
      return didCancel(state)
    case R_INPUT.DID_SAVE:
      return didSave(state, args)
    case R_INPUT.CHANGE_OK:
      return changeOk(state)
    case R_INPUT.REFRESH:
      return freeze({ ...state, ...args })
    case R_INPUT.INIT:
      return initialize(state)
    default:
      throw new Error(`Input - no such action.type: ${type}!`)
  }
}

////////////////////////////////////////////////////////////////////////////////
function changeOk(state) {
  return freeze({
    ...state,
    dirty: false,
    didSave: undefined,
    ...changeStatus(state, CHG.OK)
  })
}

////////////////////////////////////////////////////////////////////////////////
function initialize(state) {
  if (state._init || !state.xref?.current) return state
  let saveButtonType
  if (state.saveButton) {
    if (state.saveButton === true) {
      saveButtonType = 1 // hanging
    } else {
      saveButtonType = 2 // string
    }
  }
  return freeze({
    ...state,
    saveButtonType,
    _init: true,
    ...calculateHeight(state, state.xref.current)
  })
}
////////////////////////////////////////////////////////////////////////////////
function didCancel(state) {
  state.onCancel && state.onCancel(false)
  return freeze({ ...state, cancel: true })
}

////////////////////////////////////////////////////////////////////////////////
function didChange(state, { value, event, ...args }) {
  let error = state.error
  if (state.onChange) error = state.onChange(value)

  const dirty = value !== state.orig

  // require onChange sends the value back
  let statusUpdate = {}
  if (dirty && state.status !== CHG.DIRTY) {
    statusUpdate = changeStatus(state, CHG.DIRTY)
  }

  return freeze({
    ...state,
    didSave: false,
    ...calculateHeight(state, event.target),
    ...statusUpdate,
    error,
    dirty,
    value
  })
}

function changeStatus(state, status) {
  return { status, inputClass: `${state.className} ${statusClass(status)}` }
}

export function statusClass(status) {
  switch (status) {
    case CHG.DIRTY:
      return 'dirty'
    case CHG.FAILED:
      return 'failed'
    default:
      return ''
  }
}

function calculateHeight({ multiline, height, style }, elem) {
  let newHeight = height
  // const elem = ev.target
  if (multiline && elem) {
    const MIN_HEIGHT = 30
    const origHeight = elem.style.height
    // shuffling the height like this is a little game to trick the
    // scrollHeight to be as tight as possible
    elem.style.height = 'auto'
    newHeight = Math.max(MIN_HEIGHT, elem.scrollHeight)
    elem.style.height = origHeight
  } else {
    newHeight = 'auto'
  }

  if (newHeight !== height) {
    style = freeze({ ...style, height: newHeight })
  }

  return { style, height: newHeight }
}

////////////////////////////////////////////////////////////////////////////////
function didSave(state, { value: { status, error }, event: ev }) {
  if (status === CHG.SAVED) {
    state = {
      ...state,
      didSave: true,
      orig: state.value,
      dirty: false,
      error: undefined,
      ...calculateHeight(state, ev.target),
      ...changeStatus(state, status)
    }
  } else {
    state.onError && state.onError(error)
  }

  return freeze({ ...state, status, error })
}

////////////////////////////////////////////////////////////////////////////////
function didFocus(state, { event: ev }) {
  return freeze({ ...state, ...calculateHeight(state, ev.target), cancel: false })
}

////////////////////////////////////////////////////////////////////////////////
export const InputContext = createContext(null)
export default InputContext
